<template>
  <div class="">
    <store-cash-reference></store-cash-reference>
  </div>
</template>

<script>
import StoreCashReference from "@/components/profile/treasuries-cash-references/cash-reference/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    StoreCashReference,
  },
  created() {
    this.notifyQueue({
      text: "Crea Causale",
      path: "cash_reference.create",
      level: 4,
    });
  },
};
</script>
